var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "generic-lat-long-container" }, [
    _c(
      "div",
      { staticClass: "icon-container" },
      [
        _c("fa", {
          staticClass: "search-icon",
          attrs: { icon: ["fas", "search"] },
          on: { click: _vm.zoomToCoords },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-container" },
      [
        _c("input", {
          staticStyle: { display: "none" },
          attrs: { type: "text", autocomplete: "username" },
        }),
        _vm._v(" "),
        _c("b-form-input", {
          staticClass: "input-area",
          attrs: { placeholder: "Lat, Lon", autocomplete: "off" },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.zoomToCoords.apply(null, arguments)
            },
          },
          model: {
            value: _vm.latlong,
            callback: function ($$v) {
              _vm.latlong = $$v
            },
            expression: "latlong",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }